import React, { useRef, useEffect } from 'react'
import { ConnectedAudio } from './ConnectedMedia'
import {
	useResolvers,
	getTrimTimeOfCurrentSong,
	getCurrentSongUrl,
	useMissionStateSelector,
	useVolumeOf,
} from '../context'
import { VOLUMES, type MediaRef } from '../utility'

const ONE_SECOND = 1000

export default function Music(): React$Node {
	const volume = useVolumeOf(VOLUMES.MUSIC)
	const trimTimeInMs = useMissionStateSelector(getTrimTimeOfCurrentSong) || 0 // Let trim time be 0ms if there is none
	const songUrl: ?string = useMissionStateSelector(getCurrentSongUrl)
	const { songSourceResolver }: { songSourceResolver: string => string } =
		useResolvers()
	const songAudioRef: MediaRef = useRef(null)

	const resolvedSongUrl = songUrl ? songSourceResolver(songUrl) : null

	const previousSongUrl = useRef()

	const current = songAudioRef.current
	useEffect(() => {
		if (resolvedSongUrl === previousSongUrl.current) {
			return
		}
		previousSongUrl.current = resolvedSongUrl

		if (songAudioRef.current && trimTimeInMs) {
			const trimTimeInSeconds = trimTimeInMs / ONE_SECOND // Divide by ONE_SECOND because audio ref 'currentTime' is in seconds
			songAudioRef.current.currentTime = trimTimeInSeconds
		}
	}, [songAudioRef, current, trimTimeInMs, resolvedSongUrl])

	return resolvedSongUrl ? (
		<ConnectedAudio
			ref={songAudioRef}
			key={resolvedSongUrl}
			src={resolvedSongUrl}
			loop
			volume={volume}
			applyMissionPause={false}
		/>
	) : null
}
